import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b62f68f0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadCrumb: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/BreadCrumb.vue').default,Sidebar: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Sidebar.vue').default,ShareList: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/ShareList.vue').default,GoPageDetail: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/GoPageDetail.vue').default,Section: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Section.vue').default,InquiryForm: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/InquiryForm.vue').default,LikeList: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/LikeList.vue').default})
